const userRoutes = [
  {
    path: "/userList",
    name: "userList",
    component: () => import("@/views/user/userList.vue"),
    meta: {
      title: "用户列表",
      keepAlive: true,
    },
  },
  {
    path: "/blackList",
    name: "blackList",
    component: () => import("@/views/user/blackList.vue"),
    meta: {
      title: "用户黑名单",
    },
  },
  {
    path: "/blackPhoneList",
    name: "blackPhoneList",
    component: () => import("@/views/user/blackPhoneList.vue"),
    meta: {
      title: "手机号黑名单",
    },
  },
  {
    path: "/blackAddressList",
    name: "blackAddressList",
    component: () => import("@/views/user/blackAddressList.vue"),
    meta: {
      title: "地址黑名单",
    },
  },
  {
    path: "/blackHistoryList",
    name: "blackHistoryList",
    component: () => import("@/views/user/blackHistoryList.vue"),
    meta: {
      title: "历史黑名单",
    },
  },
];

export default userRoutes;
